import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeEcoV2Icon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				stroke="transparent"
				d="M8.30121 20.9234C7.34135 20.332 8.55412 17.1897 8.90841 15.053C9.11499 13.807 6.44362 14.6191 5.68816 14.3848C3.9216 13.837 5.74267 10.741 9.02778 7.30381C12.3134 3.86662 13.9781 2.67674 15.1434 3.07301C16.3082 3.46982 14.9341 7.17953 14.425 9.82365C14.1727 11.1324 17.0457 10.2205 17.7739 10.5508C18.8417 11.0353 18.7676 12.3549 14.6163 16.825C10.4651 21.2951 9.02015 21.366 8.30175 20.9234"
			/>
		</>
	),
});
